import Loadable from '@townsquare/loadable';
import { teamHealthRoute } from '@townsquare/routes/team-health';
import { teamHealthMonitorRoute } from '@townsquare/routes/team-health-monitor';
import { teamHealthMonitorEmbedRoute } from '@townsquare/routes/team-health-monitor-embed';

import { teamHealthResource } from './resource';

export const TeamHealthEmbed = Loadable({
  loader: () => import(/* webpackChunkName: "TeamHealthEmbed" */ './components/TeamHealthEmbed'),
  loading: () => null,
});

teamHealthRoute.component = TeamHealthEmbed;
teamHealthRoute.resources = [teamHealthResource];
export const teamHealthRouterRoute = teamHealthRoute;

teamHealthMonitorRoute.component = TeamHealthEmbed;
teamHealthMonitorRoute.resources = [teamHealthResource];
export const teamHealthMonitorRouterRoute = teamHealthMonitorRoute;

teamHealthMonitorEmbedRoute.component = TeamHealthEmbed;
teamHealthMonitorEmbedRoute.resources = [teamHealthResource];
export const teamHealthMonitorEmbedRouterRoute = teamHealthMonitorEmbedRoute;
